import React, { useState } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { ArrowDownIcon } from '@assets/icons/arrowDownIcon';
import { ArrowBack } from '@assets/icons/arrowBack';

const Folders:React.FC<IProps> = (props, state: IState) => {
  const [showFolders, setShowFolders] = useState<boolean>(true);

  const handleClick = (index:number) => {
    if (props.selectFolder) props.selectFolder(index);
  }

  return ( 
    <S.Root>
      <S.BoxContainer>
        <S.Header onClick={() => setShowFolders(!showFolders)}>
          <S.Title>
          Shared Files
          </S.Title>
          <S.Icons active={showFolders}>
          <ArrowDownIcon style={{fillColor: C.DARK_BLUE}} />
          </S.Icons>
        </S.Header>
        <S.FoldersContainer active={showFolders}>
          {props.folders?.length > 0 &&
            props.folders.map((folder: {id: null|string, name: string, counter: number|undefined}, index: number) => {
              return (
                <S.FolderContainer 
                  key={index} 
                  selected={props.selectedFolder?.id===folder.id}
                >
                  <S.FolderTitle onClick={() => {if (props.selectedFolder?.id!==folder.id) handleClick(index)}}>
                    {folder.name}
                  </S.FolderTitle>
                  {folder.counter &&
                  <S.ContainerInfo>
                    <S.FolderNumber>
                      {`(${folder.counter})`}
                    </S.FolderNumber>
                  </S.ContainerInfo>}
                </S.FolderContainer>
              )
              
            })
          }
        </S.FoldersContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default Folders;